import { unwrap } from '../http.js';
export function createProgressApi(client) {
    return {
        async summary(query) {
            return unwrap(await client.GET('/v1/progress/summary', { params: { query: query ?? {} } }));
        },
        async exercise(exerciseId, query) {
            return unwrap(await client.GET('/v1/progress/exercises/{exerciseId}', {
                params: { path: { exerciseId }, query: query ?? {} },
            }));
        },
    };
}
//# sourceMappingURL=progress.js.map